import { watchUpdateCalculator, watchBatchUpdateCalculator } from 'sagas/updateCalculatorSagas'
import { watchCreateCamera } from 'sagas/createCameraSaga'
import { watchCreateFloorPlan } from 'sagas/createFloorPlanSaga'
import { watchDestroyFloorPlan } from 'sagas/destroyFloorPlanSaga'
import { watchZoomToAllDevices } from 'sagas/zoomToAllDevicesSaga'
import { watchZoomToSingleCamera } from 'sagas/zoomToSingleCameraSaga'
import { watchDestroyCamera } from 'sagas/destroyCameraSaga'
import { watchSetupProjects } from 'sagas/setupProjectsSaga'
import { setupApplication } from 'sagas/setupApplicationSaga'
import { watchCreateProject } from 'sagas/createProjectSaga'
import { watchChangeProject } from 'sagas/changeProjectSaga'
import { watchDestroyProject } from 'sagas/destroyProjectSaga'
import { watchChangeCamera } from 'sagas/changeCameraSaga'
import { watchCopyCamera } from 'sagas/copyCameraSaga'
import { watchNotifyHoneybadger } from 'sagas/notifyHoneybadgerSaga'
import { watchMessage } from 'sagas/messageSaga'
import { watchNotification } from 'sagas/notificationSaga'
import { watchStartAutosave } from 'sagas/autosaveSaga'
import { watchUpdateDistanceOnInterval } from 'sagas/updateDistanceOnIntervalSaga'
import { watchChangeCameraModel } from 'sagas/changeCameraModelSaga'
import { watchSetCameraConfiguration } from 'sagas/setCameraModelSaga'
import { watchRemoveCameraConfiguration } from 'sagas/removeCameraModelSaga'
import { watchUpdatePPFHover } from 'sagas/updatePPFHoverSaga'
import { watchLoginAndRestartApp } from 'sagas/loginAndRestartAppSaga'
import { watchMergePermalinkProject } from 'sagas/mergePermalinkProjectSaga'
import { watchSetupExport } from 'sagas/setupExportSaga'
import { watchMigrateLegacyProject } from 'sagas/migrateLegacyProjectSaga'
import { watchMarkLegacyProjectHidden } from 'sagas/markLegacyProjectHiddenSaga'
import { watchThrottleUpdateMapLocation } from 'sagas/throttleUpdateMapLocationSaga'
import { watchResetSpecificManufacturerAndRestartApp } from 'sagas/resetSpecificManufacturerAndRestartAppSaga'
import { watchGetStreetview } from 'sagas/getStreetViewSaga'
import watchDuplicateProjectSaga from 'sagas/duplicateProjectSaga'
import { watchExportProgress, watchExportFeedback } from 'sagas/exportProgressSaga'
import { watchReverseGeocodeLocation, watchUpdateCameraForDrag } from 'sagas/reverseGeocodeLocationSaga'
import { watchScaleFloorPlan } from 'sagas/scaleFloorPlanSaga'
import { watchCancelScaleFloorPlan } from 'sagas/cancelScaleFloorPlanSaga'
import { watchSetupMobile } from 'sagas/setupMobileSaga'
import { watchSelectProject } from 'sagas/selectProjectSaga'
import { watchCreateMobileProject } from 'sagas/createMobileProjectSaga'
import { watchSignIn } from 'sagas/signInSaga'
import { watchChangeProjectFromStartup, watchCreateProjectFromStartup } from 'sagas/catchEarlyErrorsSaga'
import { watchSetMultiImager } from 'sagas/setMultiImagerSaga'
import { watchCreateMultiImagerLens } from 'sagas/createMultiImagerLensSaga'
import { watchCopyMultiImager } from 'sagas/copyMultiImagerSaga'
import { watchDestroyMultiImager } from 'sagas/destroyMultiImagerSaga'
import { watchUpdateFixedLens } from 'sagas/updateFixedLensSaga'
import { watchUpdateAllLenses } from 'sagas/updateAllLensesSaga'
import { watchWaitForMapIdle } from 'sagas/waitForMapIdleSaga'
import { watchZoomToNetworkCloset } from 'sagas/zoomToNetworkClosetSaga'
import { watchCheckLocationSearch } from 'sagas/checkLocationSearchSaga'
import { watchCheckOfflineLimits } from 'sagas/checkOfflineLimitsSaga'
import { watchZoomToWiredDevice } from 'sagas/zoomToWiredDeviceSaga'
import { watchChangeWiredDeviceType } from 'sagas/changeWiredDeviceTypeSaga'
import { watchZoomToDoorController } from 'sagas/zoomToDoorControllerSaga'
import { watchDestroyDoorController } from 'sagas/destroyDoorControllerSaga'
import { watchChangeMainControllerModel } from 'sagas/changeMainControllerModelSaga'

export default function * rootSaga(dispatch) {
  yield [
    setupApplication(),
    watchStartAutosave(),
    watchChangeProjectFromStartup(),
    watchCreateProjectFromStartup(),
    watchUpdateCalculator(),
    watchBatchUpdateCalculator(),
    watchCreateCamera(),
    watchCreateFloorPlan(),
    watchDestroyFloorPlan(),
    watchZoomToAllDevices(),
    watchZoomToSingleCamera(),
    watchDestroyCamera(),
    watchSetupProjects(),
    watchCreateProject(),
    watchChangeProject(),
    watchDestroyProject(),
    watchChangeCamera(),
    watchNotifyHoneybadger(),
    watchUpdateDistanceOnInterval(),
    watchChangeCameraModel(),
    watchSetCameraConfiguration(),
    watchRemoveCameraConfiguration(),
    watchMessage(),
    watchNotification(),
    watchLoginAndRestartApp(),
    watchMergePermalinkProject(),
    watchSetupExport(),
    watchUpdatePPFHover(),
    watchMigrateLegacyProject(),
    watchMarkLegacyProjectHidden(),
    watchThrottleUpdateMapLocation(),
    watchCopyCamera(),
    watchDuplicateProjectSaga(),
    watchResetSpecificManufacturerAndRestartApp(),
    watchGetStreetview(),
    watchExportProgress(dispatch),
    watchExportFeedback(),
    watchReverseGeocodeLocation(),
    watchUpdateCameraForDrag(),
    watchScaleFloorPlan(),
    watchCancelScaleFloorPlan(),
    watchSetupMobile(),
    watchSelectProject(),
    watchCreateMobileProject(),
    watchSignIn(),
    watchSetMultiImager(),
    watchCreateMultiImagerLens(),
    watchCopyMultiImager(),
    watchDestroyMultiImager(),
    watchUpdateFixedLens(),
    watchUpdateAllLenses(),
    watchWaitForMapIdle(),
    watchZoomToNetworkCloset(),
    watchCheckLocationSearch(),
    watchCheckOfflineLimits(),
    watchZoomToWiredDevice(),
    watchChangeWiredDeviceType(),
    watchZoomToDoorController(),
    watchDestroyDoorController(),
    watchChangeMainControllerModel()
  ]
}



// WEBPACK FOOTER //
// ./src/sagas/index.js